import { datadogLogs } from '@datadog/browser-logs';
import Config from 'Config';

// Datadog
const DD_CLIENT_TOKEN = 'pub0896ac42d510b8dd901caeb49bbd00ce';

export function initDatadog() {
  datadogLogs.init({
    clientToken: DD_CLIENT_TOKEN,
    forwardErrorsToLogs: false,
    sampleRate: 100,
    env: Config.Environment.DATADOG_ENVIRONMENT ?? 'stage',
    service: 'r101-frontend.browser',
    silentMultipleInit: true,
  });
}
